import { render, staticRenderFns } from "./whitelistID.vue?vue&type=template&id=0e0461b9&scoped=true"
import script from "./whitelistID.vue?vue&type=script&lang=ts"
export * from "./whitelistID.vue?vue&type=script&lang=ts"
import style0 from "./whitelistID.vue?vue&type=style&index=0&id=0e0461b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0461b9",
  null
  
)

export default component.exports